import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action, select, Store} from '@ngrx/store';
import * as actionsUi from './einstellungen.actions.ui';
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import {GetBenutzerEinstellungenAdminAction, GetBenutzerListeAction, PostBenutzerIncidentManagementSichtbarkeitAdminAction, PostBenutzerTroubleTicketsSichtbarkeitAdminAction} from '../../client-ngrx/benutzerverwaltung';
import {BenutzerSelektiertAction, SetzeIncidentManagementSichtbar, SetzeTroubleTicketSichtbarAction} from './einstellungen.actions.ui';
import {getSelectedBenutzer, PageState} from './einstellungen.reducer';
import {Benutzer, BenutzerSichtbarkeitRequest} from '../../clients/benutzerverwaltung';

@Injectable()
export class EinstellungenPageUiEffects {

    @Effect()
    pageReset$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET)
        , flatMap(() => {
            return [new GetBenutzerListeAction()];
        })
    );

    @Effect()
    benutzerListeLaden$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.BENUTZER_LISTE_LADEN)
        , flatMap(() => {
            return [new GetBenutzerListeAction()];
        })
    );

    @Effect()
    benutzerSelektiert$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.BENUTZER_SELEKTIERT)
        , filter((x: BenutzerSelektiertAction) => x.payload !== null && x.payload.benutzer_id !== null)
        , map((x: BenutzerSelektiertAction) => {
            return new GetBenutzerEinstellungenAdminAction(x.payload.benutzer_id);
        })
    );

    @Effect()
    troubleTicketSichbarkeit$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.SETZE_TROUBLE_TICKET_SICHTBAR)
        , withLatestFrom(this.store.pipe(select(getSelectedBenutzer)))
        , filter(([x, selectedBenutzer]: [SetzeTroubleTicketSichtbarAction, Benutzer]) =>
            x.payload !== null && selectedBenutzer !== null)
        , map(([x, selectedBenutzer]) => {
            const request: BenutzerSichtbarkeitRequest = {
                benutzer_id: selectedBenutzer.benutzer_id,
                ist_sichtbar: x.payload
            };
            return new PostBenutzerTroubleTicketsSichtbarkeitAdminAction(request);
        })
    );

    @Effect()
    incidentManagementSichbarkeit$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.SETZE_INCIDENT_MANAGEMENT_SICHTBAR)
        , withLatestFrom(this.store.pipe(select(getSelectedBenutzer)))
        , filter(([x, selectedBenutzer]: [SetzeIncidentManagementSichtbar, Benutzer]) =>
            x.payload !== null && selectedBenutzer !== null)
        , map(([x, selectedBenutzer]) => {
            const request: BenutzerSichtbarkeitRequest = {
                benutzer_id: selectedBenutzer.benutzer_id,
                ist_sichtbar: x.payload
            };
            return new PostBenutzerIncidentManagementSichtbarkeitAdminAction(request);
        })
    );

    private dokumentId: string = null;

    constructor(private actions$: Actions,
                private store: Store<PageState>) {
    }
}
